import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { UnavailableIndicator } from './UnavailableIndicator';

type PromptPanelProps = {
  prompt: string | null;
  jobSelected: boolean;
};

/** The selected job's extraction prompt, in a dialog opened from a button by
 * the page title. Disabled until a job is selected. */
export const PromptPanel = ({ prompt, jobSelected }: PromptPanelProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<DescriptionOutlinedIcon />}
        disabled={!jobSelected}
        onClick={() => setOpen(true)}
      >
        Extraction prompt
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        slotProps={{
          backdrop: { sx: { backdropFilter: 'blur(3px)' } },
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Extraction prompt
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ maxHeight: '70vh' }}>
          <Typography
            variant="body1"
            sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
          >
            {prompt ?? <UnavailableIndicator label="No prompt available" />}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};
